import { createContext } from 'react'

const noop = () => {}

interface Context {
  lastInteraction: number
  registerInteraction: () => void
}

const LastInteractionContext = createContext<Context>({
  lastInteraction: null,
  registerInteraction: noop
})

export default LastInteractionContext
